// src/lib/firebase.js

const firebaseConfig = {
  apiKey: 'AIzaSyAaXMBdFkhjVmI_6UulkkbGXCLG95lO7tM',
  authDomain: 'orderq-eeae2.firebaseapp.com',
  projectId: 'orderq-eeae2',
  storageBucket: 'orderq-eeae2.firebasestorage.app',
  messagingSenderId: '203112335870',
  appId: '1:203112335870:web:7654b7a1b314303e07d8af',
  measurementId: 'G-BESCF9VM3V'
};

let messagingInstance = null;

// Dynamically load Firebase ONLY when this is called
const getFirebaseMessaging = async () => {
  if (messagingInstance) return messagingInstance;
  
  const { initializeApp } = await import('firebase/app');
  const { getMessaging } = await import('firebase/messaging');
  
  const app = initializeApp(firebaseConfig);
  messagingInstance = getMessaging(app);
  return messagingInstance;
};

export const requestFCMToken = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      const messaging = await getFirebaseMessaging();
      const { getToken } = await import('firebase/messaging'); 
      
      const token = await getToken(messaging, { 
        vapidKey: process.env.REACT_APP_VAPID_KEY 
      });
      return token;
    }
  } catch (error) {
    console.error('FCM Token Error:', error);
    return null;
  }
};

export const setupForegroundListener = async (callback) => {
  try {
    const messaging = await getFirebaseMessaging();
    const { onMessage } = await import('firebase/messaging'); 
    return onMessage(messaging, callback);
  } catch (error) {
    console.error('FCM Listener Error:', error);
  }
};